import { useRef } from "react";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import SwiperType, { Mousewheel, Navigation } from "swiper";
import "swiper/modules/navigation/navigation.min.css";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import "swiper/swiper.min.css";
import NextPrevIcon from "../../../../Shared/NextPrevIcon/NextPrevIcon";
import styles from "./PredefinedInterpretations.module.css";

type PredefinedInterpretationsProps = {
  items: string[];
  onItemClick?: (item: string) => void;
};

const PredefinedInterpretations = ({
  items,
  onItemClick,
}: PredefinedInterpretationsProps) => {
  const swiperRef = useRef<SwiperType>();

  const itemClickedHandler = (item: string) => {
    if (onItemClick) {
      onItemClick(item);
    }
  };

  const setSwiperRef = (swiper: SwiperType) => {
    swiperRef.current = swiper;
  };

  return (
    <div className="d-flex align-items-center">
      {items?.length > 2 && (
        <Button variant="" className="p-0 prev-btn">
          <NextPrevIcon />
        </Button>
      )}

      <Swiper
        onSwiper={setSwiperRef}
        modules={[Navigation, Mousewheel]}
        navigation={{
          prevEl: ".prev-btn",
          nextEl: ".next-btn",
        }}
        uniqueNavElements={true}
        mousewheel={true}
        slidesPerView="auto"
        spaceBetween={10}
        className="h-100 flex-grow-1 px-1"
      >
        {items.map((item, index) => (
          <SwiperSlide key={`${index}_${item}`} className="w-auto">
            <Badge
              pill
              className={`py-2 px-3 cursor-pointer ${styles.chip}`}
              onClick={() => itemClickedHandler(item)}
            >
              {item}
            </Badge>
          </SwiperSlide>
        ))}
      </Swiper>

      {items?.length > 2 && (
        <Button variant="" className="p-0 next-btn">
          <NextPrevIcon next />
        </Button>
      )}
    </div>
  );
};

export default PredefinedInterpretations;
